













































































import {
  Component,
  Vue,
  Prop,
  Watch
} from "vue-property-decorator";
import bcdata from "../assets/data";
import CardItem from "@/components/CardItem.vue";
import DetailCard from "@/components/DetailCard.vue";
import NavMenu from '@/components/NavMenu.vue';
import {
  BCard,
  BCardText,
  BTabs,
  BTab,
} from 'bootstrap-vue';
import {
  library
} from '@fortawesome/fontawesome-svg-core';
import {
  faThumbsUp,
  faThumbsDown,
} from '@fortawesome/free-solid-svg-icons';
import {
  dom
} from '@fortawesome/fontawesome-svg-core';

@Component({
  components: {
    CardItem,
    DetailCard,
    NavMenu,
    BCard,
    BCardText,
    BTabs,
    BTab,
  },
})
export default class Detail extends Vue {
  @Prop() private msg!: string;
  private displayMode = "standard";
  private editMode = false;
  private archData = bcdata.archData;
  private typeData = bcdata.typeData;
  private ecoData = bcdata.ecoData;
  private riskData = bcdata.riskData;
  private bcArchData = bcdata.archList;

  private arch: any = {};
  private selectTab: number = 0;

  constructor() {
    super();
  }

  beforeMount() {
    this.arch = this.bcArchData.find(_ => _.id == Number(this.$route.params.id));
    library.add(faThumbsUp, faThumbsDown);
    dom.watch(); // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
  }

  @Watch("$route")
  routeChanged(to: any, from: any) {
    this.arch = this.bcArchData.find(_ => _.id == Number(this.$route.params.id));
  }
}
